import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const BLOG_DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
});

// Format an ISO 8601 date (YYYY-MM-DD) as "Month D, YYYY" without timezone drift.
export function formatBlogDate(iso: string): string {
  return BLOG_DATE_FORMATTER.format(new Date(`${iso}T00:00:00Z`));
}
